import { Link, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import SituacaoProcessoChip from "../../../../components/SituacaoProcessoChip";
import moment from "moment";
import { ResponsiveTableProps } from ".";

export default function DesktopTable({
    processos,
    handleOpenModalDetail,
    total = 0
}: ResponsiveTableProps) {
    return (
        <>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell rowSpan={2} style={{ fontWeight: 'bold' }}>Processo</TableCell>
                        <TableCell rowSpan={2} style={{ fontWeight: 'bold' }}>Criado por</TableCell>
                        <TableCell rowSpan={2} style={{ fontWeight: 'bold' }}>Tarefa em andamento</TableCell>
                        <TableCell rowSpan={2} style={{ fontWeight: 'bold' }}>Situação</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        processos.map((row: any) => (
                            <TableRow key={row.codigo}>
                                <TableCell>
                                    <Link onClick={() => handleOpenModalDetail(row.codigo)} component="div" sx={{ cursor: 'pointer' }}>#{row.codigo}</Link>
                                    <Typography variant='caption'>{moment(row.created_at).format('DD/MM/YYYY HH:mm')}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography>{row.usuario}</Typography>
                                    <Typography variant='caption'>{row.perfil}</Typography>
                                </TableCell>
                                <TableCell>
                                    {row.situacao === 'Finalizado' && '-'}
                                    {
                                        row.situacao !== 'Finalizado' &&
                                        <>
                                            <Typography>{row.tarefa_atual.titulo}</Typography>
                                            <Typography variant='caption'>{row.tarefa_atual.perfil} {row.tarefa_atual.usuario ? '/ ' + row.tarefa_atual.usuario : ''}</Typography>
                                        </>
                                    }
                                </TableCell>
                                <TableCell>
                                    <SituacaoProcessoChip situacao={row.situacao} />
                                </TableCell>
                            </TableRow>
                        ))
                    }

                    {
                        total === 0 &&
                        <TableRow>
                            <TableCell colSpan={4}>Nenhum item para exibir</TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
        </>
    )
}